// @ts-ignore
import pluralize from 'pluralize';
import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { StatusEntry } from '@/modules/statusentry/models/StatusEntry';
import { EstateStatusKey } from '@/modules/estate/constants/EstateStatusKey';

export class StatusEntryCollection extends ModelCollection<StatusEntry> {
  constructor(items: StatusEntry[] | StatusEntryCollection | null = null) {
    super(items, StatusEntry);
  }

  static mapModel(
    items: StatusEntry[] | StatusEntryCollection | null = null
  ): StatusEntryCollection {
    return new this(items);
  }

  get statusTimes(): Partial<Record<EstateStatusKey, number>> {
    return this.availableStatusKeys.reduce(
      (acc: Partial<Record<EstateStatusKey, number>>, key: EstateStatusKey) => {
        acc[key] = this.getEntriesForStatus(key).reduce(
          (acc: number, status: StatusEntry) => acc + Math.floor(status.timeInStatus),
          0
        );

        return acc;
      },
      {}
    );
  }

  get displayStatusTimes(): Partial<Record<EstateStatusKey, string>> {
    return Object.fromEntries(
      Object.entries(this.statusTimes).map((entry: [string, number]) => {
        const days: number = entry[1];

        return [entry[0], days < 1 ? '< 1 day' : `${days} ${pluralize('day', days)}`];
      })
    );
  }

  get availableStatusKeys(): EstateStatusKey[] {
    const entries: EstateStatusKey[] =
      this.items?.map((item: StatusEntry) => item.status as EstateStatusKey) ?? [];

    return [...new Set(entries)];
  }

  private getEntriesForStatus(key: string): StatusEntry[] {
    return this.items?.filter((item: StatusEntry) => item.status === key) ?? [];
  }
}
